import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { FilteredFieldContext } from '../../providers/filtered-field.provider';
import { getFieldGroups, getFilteredProperties } from '../../utils';
import { SchemaContext, SchemaProvider } from '../../providers/SchemaProvider';
import { AnyOfField } from './AnyOfField';
import { GroupFields } from './GroupFields';
import { ObjectFieldInner } from './ObjectFieldInner';
const SPACE_REGEX = /\s/g;
export const ObjectFieldGrouping = ({ propName }) => {
    const { schema } = useContext(SchemaContext);
    const { filteredFieldText } = useContext(FilteredFieldContext);
    const groupedProperties = useMemo(() => {
        const cleanQueryTerm = filteredFieldText.replace(SPACE_REGEX, '').toLowerCase();
        const filteredProperties = getFilteredProperties(schema.properties, cleanQueryTerm);
        return getFieldGroups(filteredProperties);
    }, [filteredFieldText, schema.properties]);
    const requiredProperties = Array.isArray(schema.required) ? schema.required : [];
    return (_jsxs(_Fragment, { children: [_jsx(SchemaProvider, { schema: { properties: groupedProperties.common }, children: _jsx(ObjectFieldInner, { propName: propName, requiredProperties: requiredProperties }) }), Array.isArray(schema.anyOf) && _jsx(AnyOfField, { propName: propName, anyOf: schema.anyOf }), _jsx(GroupFields, { propName: propName, groups: groupedProperties.groups, requiredProperties: requiredProperties })] }));
};
//# sourceMappingURL=ObjectFieldGrouping.js.map